var _path, _path2, _line, _line2, _line3, _circle, _path3, _line4, _line5, _line6, _circle2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 342.48449,
    height: 545.06119,
    viewBox: "0 0 342.48449 545.06119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m174.61614,532.59794l-.00666.00666c-.06048-.06846-.12261-.13593-.18808-.20139-1.72084-1.72084-4.51083-1.72079-6.23162,0s-1.72084,4.51079,0,6.23162c.06547.06547.13293.12761.20139.18808l-.00666.00666,6.23162,6.23162,6.23162-6.23162c1.72079-1.72079,1.72079-4.51083,0-6.23162s-4.51083-1.72079-6.23162,0Z",
    fill: "#8971c9",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m174.82707,231.82534l-.00666.00666c-.06048-.06846-.12261-.13593-.18808-.20139-1.72084-1.72084-4.51083-1.72079-6.23162,0s-1.72084,4.51079,0,6.23162c.06547.06547.13293.12761.20139.18808l-.00666.00666,6.23162,6.23162,6.23162-6.23162c1.72079-1.72079,1.72079-4.51083,0-6.23162s-4.51083-1.72079-6.23162,0Z",
    fill: "#8971c9",
    strokeWidth: 0
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 28.3715,
    y1: 5.40409,
    x2: 99.66202,
    y2: 5.40409,
    fill: "none",
    stroke: "#090814",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 28.3715,
    y1: 32.42457,
    x2: 178.33512,
    y2: 32.42457,
    fill: "none",
    stroke: "#090814",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 28.3715,
    y1: 20.26535,
    x2: 243.18425,
    y2: 20.26535,
    fill: "none",
    stroke: "#090814",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.15921,
    cy: 12.15921,
    r: 12.15921,
    fill: "#8971c9",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m332.08299,220.21685H38.09748c-5.73558,0-10.4015-4.66657-10.4015-10.40183V55.66112c0-5.73525,4.66591-10.40183,10.4015-10.40183h293.98551c5.73558,0,10.4015,4.66657,10.4015,10.40183v154.15391c0,5.73525-4.66591,10.40183-10.4015,10.40183Z",
    fill: "#d8d8d8",
    strokeWidth: 0
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 28.3715,
    y1: 306.40409,
    x2: 99.66202,
    y2: 306.40409,
    fill: "none",
    stroke: "#090814",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 28.3715,
    y1: 333.42457,
    x2: 178.33512,
    y2: 333.42457,
    fill: "none",
    stroke: "#090814",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 28.3715,
    y1: 321.26535,
    x2: 243.18425,
    y2: 321.26535,
    fill: "none",
    stroke: "#090814",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.15921,
    cy: 313.15921,
    r: 12.15921,
    fill: "#8971c9",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m332.08299,521.21685H38.09748c-5.73558,0-10.4015-4.66657-10.4015-10.40183v-154.15391c0-5.73525,4.66591-10.40183,10.4015-10.40183h293.98551c5.73558,0,10.4015,4.66657,10.4015,10.40183v154.15391c0,5.73525-4.66591,10.40183-10.4015,10.40183Z",
    fill: "#d8d8d8",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBox);
export default __webpack_public_path__ + "static/media/chatBox.b24e558f2ac95b9edd3c5390d26c60e9.svg";
export { ForwardRef as ReactComponent };